export default "__VITE_ASSET__Dvf50vbU__"